/**
 * @desc 时效监控-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.TimelinessDashboardModel>
>;
export function request(
  params: API.basics.timelinessDashboardMonitor.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessDashboardMonitor/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
